// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationModal_modalOverlay__NcpZC {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.LocationModal_modalContent__4-oPw {
    background: white;
    padding: 25px;
    border-radius: 12px;
    max-width: 400px;
    width: 90%;
    position: relative;
}

.LocationModal_closeButton__gBllZ {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #666;
}

.LocationModal_modalTitle__yPYZr {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    color: #333;
}

.LocationModal_modalText__ZWGub {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;
}

.LocationModal_modalButton__fJtNQ {
    background-color: #f86a6e;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    width: 100%;
}

.LocationModal_modalButton__fJtNQ:hover {
    background-color: #e55d61;
}
`, "",{"version":3,"sources":["webpack://./src/components/organism/LocationModal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modalContent {\n    background: white;\n    padding: 25px;\n    border-radius: 12px;\n    max-width: 400px;\n    width: 90%;\n    position: relative;\n}\n\n.closeButton {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n    color: #666;\n}\n\n.modalTitle {\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 15px;\n    color: #333;\n}\n\n.modalText {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 20px;\n    line-height: 1.5;\n}\n\n.modalButton {\n    background-color: #f86a6e;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    width: 100%;\n}\n\n.modalButton:hover {\n    background-color: #e55d61;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `LocationModal_modalOverlay__NcpZC`,
	"modalContent": `LocationModal_modalContent__4-oPw`,
	"closeButton": `LocationModal_closeButton__gBllZ`,
	"modalTitle": `LocationModal_modalTitle__yPYZr`,
	"modalText": `LocationModal_modalText__ZWGub`,
	"modalButton": `LocationModal_modalButton__fJtNQ`
};
export default ___CSS_LOADER_EXPORT___;
